import React from 'react';
import clsx from 'clsx';
import { FocusTrap } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { useDeviceType } from '../../../../../../../src';
import { useSearchStateContext } from '../provider';
import { CloseMenu } from './CloseMenu';
import { SearchBar } from './SearchBar';
import { SearchMenu, SearchMenuProps } from './SearchMenu';

export const MobileSearchMenu: Component<SearchMenuProps> = ({ vipBrands, locale }) => {
    'use memo';

    const { isSearchOpen } = useSearchStateContext();
    const isMobile = useDeviceType() === 'mobile';

    return (
        <FocusTrap isActive={isMobile && isSearchOpen} shouldFocusBack={false}>
            <section
                className={clsx(
                    'fade-in-out',
                    !isSearchOpen && 'hide',
                    'tablet:hidden',
                    'fixed inset-0 bg-background-l0 z-modal overflow-auto',
                )}
            >
                <div className={'px-1 py-0.5 flex justify-between items-center gap-1'}>
                    <SearchBar />
                    <CloseMenu />
                </div>
                <SearchMenu locale={locale} vipBrands={vipBrands} />
            </section>
        </FocusTrap>
    );
};
